import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { trimTypeActions } from "../../../../../../actions";
import DataTable from "../../../../../common/ui/table/DataTable/DataTable.component";
import {
  useGetTrimTypeQuery,
} from "../../../../../../services/api/trim-types";

const TrimTypes = () => {

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "name",
      headerName: "Trim Type Name",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "chinese_name",
      headerName: "Chinese Name",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "technical_name",
      headerName: "Technical Name",
      minWidth: 120,
      flex: 1,
    },
    {
      field: "created_at",
      headerName: "Created At",
      width: 150,
      hide: true,
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 150,
      hide: true,
    },
  ];

  const recordIdentifier = "name";

  const { data, isLoading } = useGetTrimTypeQuery();

  return (
    <Box>
      
      {/* {trimTypes && ( */}
        <DataTable
          rows={data || []}
          loading={isLoading}
          columns={columns}
          recordIdentifier={recordIdentifier}
          actionIdentifier="trimTypeActions"
        />
      {/* )}  */}
    </Box>
  );
};

export default TrimTypes;
